import { useTranslation } from 'react-i18next';
import { QuestionOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

/** Small round "?" in the profile header that opens the profile guide. */
export default function ProfileGuideButton({ onClick }) {
  const { t } = useTranslation('translations');
  const label = t('profileGuide.open');
  return (
    <Tooltip title={label}>
      <button
        type="button"
        aria-label={label}
        data-tour="profile-help"
        onClick={onClick}
        className="grid h-8 w-8 shrink-0 cursor-pointer place-items-center rounded-full border border-white/70 bg-white/15 text-sm text-white transition-colors hover:bg-white/30"
      >
        <QuestionOutlined />
      </button>
    </Tooltip>
  );
}
